import React from "react";

import { HubDialogWrapper } from "../HubDialogWrapper";
import FinancialPeriodContent from "./FinancialPeriodContent";

export const FinancialPeriodDialog = () => {
  return (
    <HubDialogWrapper maxWidth="md" name="financial-period">
      <FinancialPeriodContent />
    </HubDialogWrapper>
  );
};

export default FinancialPeriodDialog;
